import { createStyles }     from "@mantine/core";
import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => ( {
	headerChild: {
		display        : "flex",
		justifyContent : "center",
		position       : "absolute",
		left           : "50vw",
		transform      : "translate(-50%,0)"
	},
	searchBarContainer: {
		color           : theme.other.colors.text.primary,
		backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey : theme.other.paletteNew.secondaryBackgroundGrey,
		borderRadius    : "10px",

		"& .MuiTypography-body1": {
			color: theme.other.darkMode ? theme.other.paletteNew.secondaryDarkGrey : "#00000080"
		}
	},
	root: {
		backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey : theme.other.paletteNew.secondaryBackgroundGrey,
		width           : "25vw",
		borderRadius    : "10px",
		// padding         : "10px",

		"& input": {

			"&::placeholder": {
				color: theme.other.darkMode ? theme.other.paletteNew.secondaryBackgroundGrey : theme.other.paletteNew.secondaryBlack
			}
		},

		"& .MuiOutlinedInput-root": {
			padding         : "0 0.5rem",
			borderRadius    : "1rem",
			backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey : theme.other.paletteNew.secondaryBackgroundGrey,

			"& .MuiOutlinedInput-input": {
				padding: "10px"
			},

			"&.Mui-focused fieldset": {
				borderColor: `${ theme.other.paletteNew.primaryDarkBlue }`
			},

			"& fieldset": {
				borderWidth: "0px"

			}
		},

		[rooterMediaQuery.mobile]: {
			width: "100%"
		}

	},
	input: {
		fontSize: "1.4rem"
	},
	cssFocused: {
		borderColor: "#126bd5 !important"
	},
	popOver: {
		backgroundColor        : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey : theme.other.paletteNew.primaryBackgroundGrey,
		minWidht               : "500px",
		maxHeight              : "450px",
		minWidth               : "500px",
		height                 : "fit-content",
		minHeight              : "300px",
		borderRadius           : "20px",
		border                 : "none",
		zIndex                 : 100,
		overflowY              : "auto",
		boxShadow              : "0 0 40px 10px rgba(0, 0, 0, 0.1)",
		padding                : ( props?.searchTerm?.length > 2 ) ? "0" : "2rem",
		display                : "block",
		"&::-webkit-scrollbar" : {
			width      : "0", /* Remove scrollbar space */
			height     : "0",
			background : "transparent" /* Optional: just make scrollbar invisible */
		}
	},
	svgSearch: {
		width       : "2rem",
		height      : "2rem",
		marginRight : "1rem"
	},

	mobileSearchContainer: {
		display        : "flex",
		justifyContent : "center",
		padding        : "1.6rem",
		background     : theme.other.colors.background.tertiary,
		alignItems     : "center"
	},

	backIcon: {
		height      : "2rem",
		width       : "2rem",
		marginRight : "1rem"
	},

	crossIcon: {
		height : "2.6rem",
		width  : "2.6rem"
	},
	// mobile css
	mobileSearchModal: {
		 background : theme.other.colors.background.secondary,
		 height     : "100%"
		 }
} ) );
